import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import InputBox from "../../../../FormElement/InputBox";

interface ILocationSearchBoxProps {
  value?: string;
  onChange: (value: string) => void;
}

export const LocationSearchBox = ({
  value,
  onChange,
}: ILocationSearchBoxProps) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`locationActivityPage.locationActivityTable.controls.${key}`);

  const [locationName, setLocationName] = useState<string>(value || "");

  const handleLocationNameKeyPress = (
    e: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (e.key === "Enter") {
      onChange(locationName);
    }
  };
  return (
    <InputBox
      value={locationName || ""}
      onChange={(value) => setLocationName(value)}
      onKeyPress={handleLocationNameKeyPress}
      placeholder={t("search_by_name")}
      isSearch={true}
      classNameContainer={"search-input"}
    />
  );
};
